// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281147/js/" + chunkId + "." + {"44":"868d2f99","225":"ebdf2070","481":"ecfa13fd","486":"35a6d269","770":"6cbc9b42"}[chunkId] + ".0.41244239150522677.chunk.js";
};